module.exports = __webpack_public_path__ + "static/logo-hotelgest-703b6f6aec8177b3a498e7c1d4ed5e4e.png";